import { useContext } from 'react';

import { ReviewRequestContext } from '../context';

const useReviewsRequested = () => {
  const context = useContext(ReviewRequestContext);

  if (!context) {
    throw new Error('useReviewsRequested must be used within a ReviewRequestProvider');
  }

  return context;
};

export default useReviewsRequested;
